import { getCommonAssetPath } from '../../geo/config'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
const BonusComponent = () => {
   const bonusBg = getCommonAssetPath('bonus_bg.svg')
   const {t} = useTranslation()
  return (
    <div className={styles.bonusContainer}>
      <div className={styles.navTitle}>
        <span>{t("global.title1", "Регистрируйся")}</span>
      </div>
      <div className={styles.bonus}>
        <img className={styles.bonusBg} src={bonusBg} alt="bonus bg" />
        <span>{t("global.bonus", "и забирай бонус!")}</span>
      </div> 
    </div>
  )
}

export default BonusComponent
